export { ALL_METRICS } from '../../../../shared/constants/MetricsTypeConstants';

export const SAVINGS_METRICS = {
    savings: {
        label: null,
        type: 'integer',
    },
};

export const ACCOUNT_INFO_TITLE = {
    THIS_YEAR_APPLIED_SAVINGS: gettext('This Year Savings'),
    LAST_12_MONTHS_APPLIED_SAVINGS: gettext('Last 12 Months Savings'),
    THIS_DAY_POTENTIAL_SAVINGS: gettext('Today Potential Savings'),
};

export const ACCOUNT_INFO_METRICS_CONFIG = {
    THIS_YEAR_APPLIED_SAVINGS: SAVINGS_METRICS,
    LAST_12_MONTHS_APPLIED_SAVINGS: SAVINGS_METRICS,
    THIS_DAY_POTENTIAL_SAVINGS: SAVINGS_METRICS,
};
